import React from "react";
import { CheckCircle2, Circle } from "lucide-react";
import { WORKFLOW_STEPS } from "./kusurConstants";

const STEP_ORDER = ["delil", "okuma", "analiz", "rapor"];

export default function KusurWorkflowStrip({ activeStep }) {
    const idx = STEP_ORDER.indexOf(activeStep);

    return (
        <div className="flex items-center gap-1 px-3 py-2 border-b border-white/5 bg-[#0a0f18]/50 overflow-x-auto">
            {WORKFLOW_STEPS.map((s, i) => {
                const done = i < idx;
                const active = i === idx;
                return (
                    <React.Fragment key={s.id}>
                        {i > 0 ? <div className="h-px w-4 sm:w-8 bg-white/10 shrink-0" /> : null}
                        <div
                            className={`flex items-center gap-1.5 shrink-0 rounded-lg px-2 py-1 ${
                                active
                                    ? "bg-[#a31d21]/20 border border-[#a31d21]/35"
                                    : done
                                      ? "opacity-80"
                                      : "opacity-50"
                            }`}
                        >
                            {done ? (
                                <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" />
                            ) : (
                                <Circle
                                    className={`h-3.5 w-3.5 ${active ? "text-[#a31d21]" : "text-slate-600"}`}
                                />
                            )}
                            <div>
                                <div className={`text-[11px] font-medium ${active ? "text-white" : "text-slate-400"}`}>
                                    {s.label}
                                </div>
                                <div className="text-[9px] text-slate-600 hidden sm:block">{s.desc}</div>
                            </div>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}
